// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"225":"b9687bba","493":"f39bcd83","640":"68f6f230","752":"e10f202b","755":"14cea835","841":"7b6d0e9c","861":"6a31118f","880":"dbc0ac06","925":"ed1f6496","980":"3ed0addc"}[chunkId] + ".js";
};